module.exports = __webpack_public_path__ + "img/652-6966bb.png";